import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

const GET_TIME_ZONES_QUERY = gql`
  query getTimeZones {
    timeZones {
      id
      displayText
    }
  }
`;

export const useTimeZones = () => {
  const { data, loading } = useQuery(GET_TIME_ZONES_QUERY, {
    fetchPolicy: 'cache-first'
  });

  return {
    timeZones: data?.timeZones,
    loading
  };
};
